import React from 'react';
import { FilterOptionKeys } from '@mybestbrands/types';
import FilterToggle, { FilterToggleType } from '@/app/ui/components/filters/FilterToggle';

const SaleFilter = ({ isActive, type = FilterToggleType.BUTTON }: { isActive: boolean; type?: FilterToggleType }) => {
  return <FilterToggle isActive={isActive} filterKey={FilterOptionKeys.SALE} type={type} color={'red'} />;
};

export default SaleFilter;
